import { cloneDeep } from 'lodash-es'
import { LAYERS } from '../constants'

const layersById = new Map(LAYERS.map(layer => [layer.id, layer]))

export function useDetailMapHelpers() {
  // `visible` overrides the constants entry both ways: a card that wants a
  // layer created hidden (the losing planning-tier overlays, RED-293) must
  // not depend on the constants happening to say `visible: false`.
  const findLayer = (id, visible = true) => {
    const originalLayer = layersById.get(id)
    if (!originalLayer) return null

    const layerInstanceConfig = cloneDeep(originalLayer)
    if (typeof visible === 'boolean') {
      layerInstanceConfig.visible = visible
    }

    if (!layerInstanceConfig.features) {
      layerInstanceConfig.features = []
    }

    return layerInstanceConfig
  }

  return {
    findLayer,
  }
}
